import React from "react";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useNavigate } from "react-router-dom"; // Import useHistory for v5
import bgImage from "../../assets/img/bgimage-new.png";
import logo from "../../assets/img/Daimler_Login_Logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "../pages/Home";

const Login = () => {
  const { instance, accounts } = useMsal(); // Access MSAL instance from context
  const navigate = useNavigate(); // React Router's useNavigate hook

  const login = async () => {
    try {
      const loginResponse = await instance.loginPopup(); // Trigger login popup
      console.log("Login successful", loginResponse);
      const account = loginResponse && loginResponse.account;
      const idtoken = account && account.idToken;
      const userEmail = loginResponse && loginResponse?.idTokenClaims?.uid + '@tbdir.net';
      const userName = loginResponse && loginResponse?.idTokenClaims?.name;
      localStorage.setItem("myemail", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
      localStorage.setItem(
        "access-token-storage",
        JSON.stringify({ accessToken: idtoken })
      );
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="bg-white dark:bg-gray-900 bgColor">
                <div className="login_body_grid">
                  <div
                    style={{
                      background: ` url(${bgImage}) no-repeat center`,
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                    className="hidden bg-cover lg:block lg:w-2/3 login_bg_image"
                  >
                    <div
                      style={{
                        display: "grid",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80%",
                        gap: "20px",
                      }}
                    >
                      <div className="login_info">
                        <h2>{process.env.REACT_APP_NAME}</h2>
                      </div>
                      <div className="right_grid_align">
                        <span className="daimler-logo">
                          <img src={logo} alt="logo" />
                        </span>

                        <button
                          title="Sign in"
                          className="btn_login"
                          onClick={login}
                        >
                          Sign in
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="contact-text">
              Please contact{" "}
              <a
                target={"_blank"}
                rel="noreferrer"
                style={{ color: "black", textDecoration: "none" }}
                href="mailto:dw_365_DICV-Vruddhi-Support@daimlertruck.com"
              >
                <mark id="markid">
                  dw_365_DICV-Vruddhi-Support@daimlertruck.com
                </mark>
              </a>{" "}
              for access or support.
            </p>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
